import { Translatable } from "@icc/shared/helpers";

/** Przedłużka blachy */
export class BlindSheetExtension {
    id: number;
    extId: string;
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    description: string;
    /** Wysokość [mm] */
    height: number;
    /** Przypisane profile blach */
    blindSheetsIds: string[];
    /** Przypisane profile zestawów blach */
    blindSheetSetsIds: string[];
    /** Liczba przedłużek */
    amount?: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}